import React from 'react';
import Loadable from 'components/Loadable';
import {PrivateLayout} from 'components/Layouts';

import renderRoutes from 'pages/routes';

export default {
  exact: false,
  auth: true,
  path: '/activities',
  component: ({routes}) => {
    return <PrivateLayout>{renderRoutes(routes)}</PrivateLayout>;
  },
  routes: [
    {
      exact: true,
      auth: true,
      path: '/activities',
      component: Loadable({
        loader: () => import('./lists'),
      }),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/pages/back/activities/index.js